import { render, staticRenderFns } from "./Site-footer.vue?vue&type=template&id=1b37795c&"
import script from "./Site-footer.vue?vue&type=script&lang=js&"
export * from "./Site-footer.vue?vue&type=script&lang=js&"
import style0 from "./Site-footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports